import { appendIf } from '@btime/helpers'
import { useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import { integrationsClient } from '../../../../../utils/apollo/api'
import { useNotification } from '@btime/react-messager'
import { useCloseModal } from '../../../../../components/modals/ModalsContext'
import { useProjectId } from '@btime/react-session'

const MUTATION = gql`
  mutation SegwareTechnician($technicianId: Int!, $userId: Int!, $contractId: Int!, $projectId: Int!) {
    SegwareTechnician(technicianId: $technicianId, userId: $userId, contractId: $contractId, projectId: $projectId) {
      external_reference_id
    }
  }
`

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.user?.id, { path: ['user'], message: 'Campo obrigatório' }),
    ...appendIf(!form.technician?.id, { path: ['technician'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

const UseHandleSubmit = () => {
  const [loading, setLoading] = useState(false)
  const notify = useNotification()
  const closeModal = useCloseModal()
  const currentProjectId = useProjectId()
  const [mutationRequest] = useMutation(MUTATION, { client: integrationsClient })

  const request = (form, { setErrors }) => {
    const isValid = validate(form, setErrors)
    const input = {
      userId: form.user.id,
      technicianId: form.technician.id,
      contractId: form.user.contract.id,
      projectId: currentProjectId
    }

    if (isValid) {
      setLoading(true)

      return mutationRequest({
        variables: input
      }).then(resp => {
        if (!resp.errors) {
          notify.success({ title: 'Técnico cadastrado com sucesso' })
          closeModal()
        } else {
          const error = resp.errors[0]

          if (error?.message) {
            notify.error({ title: error.message })
          } else {
            notify.error({ title: 'Ocorreu um erro ao cadastrar o tecnico' })
          }

          setLoading(false)
        }
      })
    }
  }

  return [request, loading]
}

export default UseHandleSubmit
